export const engagementContentBlocksTerritories = "/engagement/content_blocks/territories";
